interface RuntimeEnv {
  /** Explicit API base URL (prod). Falls back to '/api' for the Vite proxy in dev. */
  apiBaseUrl: string;
}

function detectEnv(): RuntimeEnv {
  const explicit = import.meta.env.VITE_API_BASE_URL;
  if (typeof explicit === 'string' && explicit.length > 0) {
    return { apiBaseUrl: explicit.replace(/\/$/, '') };
  }
  return { apiBaseUrl: '/api' };
}

export const env: RuntimeEnv = detectEnv();
